import { Card, Skeleton } from '@mui/material';

function ImageCardSkeleton() {
  return (
    <Card
      sx={{
        position: 'relative',
        boxShadow: 3,
        borderRadius: 3,
        bgcolor: 'background.paper',
        p: 0,
        m: 0,
      }}
    >
      <Skeleton variant="rectangular" height={200} />
      <div className="absolute bottom-2 left-2">
        <Skeleton variant="text" width={80} />
      </div>
    </Card>
  );
}

export default ImageCardSkeleton;
